// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__crPru","left":"styles_left__i8KMB","desktopActions":"styles_desktopActions__3_i6q","title":"styles_title__22_kd"};